export default __webpack_public_path__ + "static/centauro-2dc8125470e691aad3a5d061b249bf24.jpg";